import { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import delIcon from '../../../assets/icons/new_icon/delete-2.svg';
import edit from '../../../assets/icons/new_icon/edit-2.svg';
import { ManualLegDto } from '../../../types';
import SelectCarrierDropdown from '../../global-components/selectCarrierDropdown';
import EditLegAddressModal from './editLegAddressModal';
import EditLegTypeModal from './editLegTypeModal';
interface Props {
  legData: ManualLegDto;
  setLegData: any;
  validating: boolean;
  handleRemoveLeg: any;
  index: number;
  manualLegList: ManualLegDto[];
  setManualLegList: any;
  setShowDeleteAlert?: any;
}
function ManualLegCard({
  legData,
  setLegData,
  validating,
  handleRemoveLeg,
  index,
  manualLegList,
  setManualLegList,
  setShowDeleteAlert,
}: Props) {
  const [showEditTypeModal, setShowEditTypeModal] = useState(false);
  const [showEditAddresseModal, setShowEditAddressModal] = useState(false);
  const [addressType, setAddressType] = useState('');

  return (
    <div
      className='ubbe-card my-4  ubbe-leg '
      id={`${index}_card`}
    >
      <div className=''>
        <div className='ubbe-card-header p-4'>
          <div className='d-flex justify-content-between align-items-center   flex-row w-100'>
            <div
              className='d-flex align-items-center '
              style={{ color: 'white' }}
            >
              <h6
                id={`${index}_title`}
                style={{ color: 'white' }}
                className='GlobalBoxHead fs-5 mb-0 '
              >
                {`L${index + 1}`}
              </h6>
              {/* <button
                data-bs-toggle='modal'
                data-bs-target='#edit_leg_type_modal'
                onClick={() => setShowEditTypeModal(true)}
                className='btn bg-transparent'
              >
                <i
                  className='bi bi-pencil text-white '
                  data-toggle='edit_leg-tooltip'
                  data-placement='top'
                  title='Edit Leg Type'
                ></i>
              </button> */}
            </div>
            <div className='col-3 col-lg-2 text-end '>
              <button
                id='pickup_delete_button'
                onClick={() => {
                  setShowDeleteAlert && setShowDeleteAlert(true);
                  handleRemoveLeg(index);
                }}
                className='btn-ubbe-no-style'
              >
                <img
                  alt='delete-icon'
                  src={delIcon}
                  className='packageBoxIcon'
                  style={{
                    backgroundColor: '#FFFFFF33',
                  }}
                />
              </button>
            </div>
          </div>
        </div>
        <div className='p-4 pt-2'>
          <div className='row mt-2'>
            <div className='col-6 col-sm-4 col-md-3'>
              <label
                htmlFor={`${index}_carrier`}
                className='form-label labelText mb-0'
              >
                Carrier<span className='text-danger'>*</span>
              </label>
              <SelectCarrierDropdown
                selectedCarrierCode={legData.carrier_code}
                setSelectedCarrier={(val: any) => {
                  setLegData({
                    ...legData,
                    carrier_id: val?.id,
                    carrier_code: val?.code,
                    carrier_name: val?.name,
                    legValidations: {
                      ...legData.legValidations,
                      carrier_code: val.code !== '' && val.code !== undefined,
                    },
                  });
                }}
              />
              {validating &&
                (legData?.carrier_code === '' ||
                  legData?.carrier_code === undefined) && (
                  <div className='error_text'>
                    {'Please provide a valid carrier.'}
                  </div>
                )}
            </div>
            <div className='col-6 col-sm-4 col-md-3'>
              <div className='d-flex justify-content-between align-items-center '>
                <label
                  htmlFor='origin_details'
                  className='form-label labelText mb-0'
                >
                  Origin<span className='text-danger'>*</span>
                </label>
                {/* <button
                  className='btn-ubbe-no-style'
                  type='button'
                  onClick={() => {
                    setShowEditAddressModal(true);
                    setAddressType('origin');
                  }}
                  data-bs-toggle='modal'
                  data-bs-target='#edit_address_modal'
                >
                  <img src={edit} alt='' />
                </button> */}
              </div>
              <div className='input-group'>
                <input
                  id={`${index}_origin_details`}
                  type='text'
                  className={`form-control ubbe-input ${
                    legData?.origin?.city ? 'highlighted-border' : ''
                  }`}
                  aria-label='origin_details'
                  value={`${legData.origin.city}, ${legData.origin.province}`}
                  onClick={() => {
                    setShowEditAddressModal(true);
                    setAddressType('origin');
                  }}
                  readOnly
                />
                <div className='input-group-append'></div>
              </div>
            </div>
            <div className='col-6 col-sm-4 col-md-3'>
              <div className='d-flex justify-content-between align-items-center '>
                <label
                  htmlFor='destination_details'
                  className='form-label labelText mb-0'
                >
                  Destination<span className='text-danger'>*</span>
                </label>
                {/* <button
                  className='btn-ubbe-no-style'
                  type='button'
                  onClick={() => {
                    setShowEditAddressModal(true);
                    setAddressType('destination');
                  }}
                  data-bs-toggle='modal'
                  data-bs-target='#edit_address_modal'
                >
                  <img
                    src={edit}
                    alt=''
                  />
                </button> */}
              </div>
              <div className='input-group'>
                <input
                  id={`${index}_destination_details`}
                  type='text'
                  className={`form-control ubbe-input ${
                    legData?.destination?.city ? 'highlighted-border' : ''
                  }`}
                  aria-label='destination_details'
                  value={`${legData.destination.city}, ${legData.destination.province}`}
                  onClick={() => {
                    setShowEditAddressModal(true);
                    setAddressType('destination');
                  }}
                  readOnly
                />
                <div className='input-group-append'></div>
              </div>
            </div>
            <div className='col-6 col-sm-4 col-md-3'>
              <label
                htmlFor={`${index}_service`}
                className='form-label labelText mb-0'
                data-toggle='service-tooltip'
                data-placement='top'
                title='Specify Service level booked with carrier'
              >
                Service <span className='text-danger'>*</span>
              </label>
              <input
                type='input'
                className={`form-control ubbe-input ${
                  legData?.service_code ? 'highlighted-border' : ''
                }`}
                id={`${index}_service`}
                aria-label='Leg'
                autoComplete='new-password'
                placeholder='Code'
                value={legData.service_code}
                onChange={(e) => {
                  setLegData({
                    ...legData,
                    service_code: e.target.value,
                    service_name: e.target.value,
                    legValidations: {
                      ...legData.legValidations,
                      service_code: e.target.value !== '',
                    },
                  });
                }}
              />
              {validating && legData.service_code === '' && (
                <div className='error_text'>
                  {'Please provide a valid service code.'}
                </div>
              )}
            </div>
          </div>
          <div className='row mt-4'>
            <div className='col-6 col-sm-4 col-md-3'>
              <label
                htmlFor={`${index}_tracking`}
                className='form-label labelText mb-0  mt-2'
                data-toggle='tracking-tooltip'
                data-placement='top'
                title='BOL, PRO #, AWB'
              >
                Tracking<span className='text-danger'>*</span>
              </label>
              <input
                type='input'
                className={`form-control ubbe-input ${
                  legData?.tracking_identifier ? 'highlighted-border' : ''
                }`}
                id={`${index}_tracking`}
                aria-label='Leg'
                autoComplete='new-password'
                placeholder='Tracking Number'
                value={legData?.tracking_identifier}
                onChange={(e) => {
                  setLegData({
                    ...legData,
                    tracking_identifier: e.target.value,
                    legValidations: {
                      ...legData.legValidations,
                      tracking_identifier: e.target.value !== '',
                    },
                  });
                }}
              />
              {validating && legData.tracking_identifier === '' && (
                <div className='error_text'>
                  {'Please provide a valid tracking.'}
                </div>
              )}
            </div>
            <div className='col-6 col-sm-4 col-md-3'>
              <label
                htmlFor={`${index}_pickup_num`}
                className='form-label labelText mb-0 mt-2'
              >
                Pickup<span className='text-danger'>*</span>
              </label>
              <input
                type='input'
                className={`form-control ubbe-input ${
                  legData?.carrier_pickup_identifier ? 'highlighted-border' : ''
                }`}
                id={`${index}_pickup_num`}
                aria-label='Leg'
                autoComplete='new-password'
                placeholder='Pickup Number'
                value={legData.carrier_pickup_identifier}
                onChange={(e) => {
                  setLegData({
                    ...legData,
                    carrier_pickup_identifier: e.target.value,
                    legValidations: {
                      ...legData.legValidations,
                      carrier_pickup_identifier: e.target.value !== '',
                    },
                  });
                }}
              />
              {validating && legData.carrier_pickup_identifier === '' && (
                <div className='error_text'>
                  {'Please provide a valid pickup id.'}
                </div>
              )}
            </div>
            <div className='col-6 col-sm-4 col-md-3'>
              <label
                htmlFor={`${index}_transit_days`}
                className='form-label labelText mb-0 mt-2'
                data-toggle='transit_days-tooltip'
                data-placement='top'
                title='Enter transit time from the carrier or approximate days'
              >
                Transit Days<span className='text-danger'>*</span>
              </label>
              <input
                type='input'
                className={`form-control ubbe-input ${
                  legData?.transit_days ? 'highlighted-border' : ''
                }`}
                id={`${index}_transit_days`}
                aria-label='Leg'
                autoComplete='new-password'
                placeholder='Transit Days'
                value={legData.transit_days}
                onChange={(e) => {
                  setLegData({
                    ...legData,
                    transit_days: e.target.value,
                    legValidations: {
                      ...legData.legValidations,
                      transit_days: e.target.value !== '',
                    },
                  });
                }}
              />
              {validating && legData.transit_days === '' && (
                <div className='error_text'>
                  {'Please provide a valid number of transit days.'}
                </div>
              )}
            </div>
            <div className='col-6 col-sm-4 col-md-3'>
              <label
                htmlFor={`${index}_estimated_delivery_date`}
                className='form-label labelText mb-0 mt-2'
              >
                Est. Delivery Date<span className='text-danger'>*</span>
              </label>
              <DatePicker
                id={`${index}_estimated_delivery_date`}
                selected={new Date(legData.estimated_delivery_date)}
                onChange={(date: any) => {
                  setLegData({
                    ...legData,
                    estimated_delivery_date: date.toISOString(),
                  });
                }}
                className={`form-control ubbe-input ${
                  legData?.estimated_delivery_date ? 'highlighted-border' : ''
                }`}
                placeholderText={'Sailing Date'}
                dateFormat='yyyy-MM-dd'
                autoComplete='off'
                showIcon={true}
                minDate={new Date()}
                calendarIconClassname='calendarIcon'
              />
            </div>
          </div>
          <div className='row mt-4'>
            <div className='col-6 col-sm-4 col-md-3'>
              <label
                htmlFor={`${index}_freight`}
                className='form-label labelText mb-0'
                data-toggle='freight-tooltip'
                data-placement='top'
                title='Freight charges without any surcharges'
              >
                Freight<span className='text-danger'>*</span>
              </label>
              <input
                type='input'
                className={`form-control ubbe-input ${
                  legData?.freight ? 'highlighted-border' : ''
                }`}
                id={`${index}_freight`}
                aria-label='Leg'
                autoComplete='new-password'
                placeholder='Freight'
                value={legData.freight}
                onChange={(e) => {
                  setLegData({
                    ...legData,
                    freight: e.target.value,
                    legValidations: {
                      ...legData.legValidations,
                      freight: e.target.value !== '',
                    },
                  });
                }}
              />
              {validating && legData.freight === '' && (
                <div className='error_text'>
                  {'Please provide a valid freight.'}
                </div>
              )}
            </div>
            <div className='col-6 col-sm-4 col-md-3'>
              <label
                htmlFor={`${index}_surcharge`}
                className='form-label labelText mb-0'
                data-toggle='surcharge-tooltip'
                data-placement='top'
                title='All Surcharges added together'
              >
                Surcharge<span className='text-danger'>*</span>
              </label>
              <input
                type='input'
                className={`form-control ubbe-input ${
                  legData?.surcharge ? 'highlighted-border' : ''
                }`}
                id={`${index}_surcharge`}
                aria-label='Leg'
                autoComplete='new-password'
                placeholder='Surcharge'
                value={legData.surcharge}
                onChange={(e) => {
                  setLegData({
                    ...legData,
                    surcharge: e.target.value,
                    legValidations: {
                      ...legData.legValidations,
                      surcharge: e.target.value !== '',
                    },
                  });
                }}
              />
              {validating && legData.surcharge === '' && (
                <div className='error_text'>
                  {'Please provide a valid surcharge.'}
                </div>
              )}
            </div>
            <div className='col-6 col-sm-4 col-md-3'>
              <label
                htmlFor='tax'
                className='form-label labelText mb-0'
              >
                Tax<span className='text-danger'>*</span>
              </label>
              <input
                type='input'
                className={`form-control ubbe-input ${
                  legData?.tax ? 'highlighted-border' : ''
                }`}
                id={`${index}_tax`}
                aria-label='Leg'
                autoComplete='new-password'
                placeholder='Tax'
                value={legData.tax}
                onChange={(e) => {
                  setLegData({
                    ...legData,
                    tax: e.target.value,
                    legValidations: {
                      ...legData.legValidations,
                      tax: e.target.value !== '',
                    },
                  });
                }}
              />
              {validating && legData.tax === '' && (
                <div className='error_text'>
                  {'Please provide a valid tax.'}
                </div>
              )}
            </div>
            <div className='col-6 col-sm-4 col-md-3'>
              <label
                htmlFor='cost'
                className='form-label labelText mb-0'
                data-toggle='cost-tooltip'
                data-placement='top'
                title='Freight + Surcharge + Tax'
              >
                Cost<span className='text-danger'>*</span>
              </label>
              <input
                type='input'
                className={`form-control ubbe-input ${
                  legData?.cost ? 'highlighted-border' : ''
                }`}
                id={`${index}_cost`}
                aria-label='Leg'
                autoComplete='new-password'
                placeholder='Cost'
                value={legData.cost}
                onChange={(e) => {
                  setLegData({
                    ...legData,
                    cost: e.target.value,
                    legValidations: {
                      ...legData.legValidations,
                      cost: e.target.value !== '',
                    },
                  });
                }}
              />
              {validating && legData.cost === '' && (
                <div className='error_text'>
                  {'Please provide a valid cost.'}
                </div>
              )}
            </div>
          </div>
          <div className='row mt-4'></div>
        </div>
      </div>
      {showEditTypeModal && (
        <EditLegTypeModal
          onClose={() => setShowEditTypeModal(false)}
          manualLegList={manualLegList}
          setManualLegList={setManualLegList}
          item={legData}
          index={index}
        />
      )}
      {showEditAddresseModal && (
        <EditLegAddressModal
          onClose={() => {
            setShowEditAddressModal(false);
            setAddressType('');
          }}
          manualLegList={manualLegList}
          setManualLegList={setManualLegList}
          item={legData}
          index={index}
          addressType={addressType}
        />
      )}
    </div>
  );
}

export default ManualLegCard;
